"use strict";

var oAuth2Request = require('./request');
var oAuth2CodeFlow = require('./code');
var oAuth2TokenFlow = require('./token');
var oAuth2CredentialsFlow = require('./credentials');

/**
 * Map authentication methods to a function.
 *
 * @type {Object}
 */
module.exports.code = oAuth2CodeFlow;
module.exports.token = oAuth2TokenFlow;
module.exports.credentials = oAuth2CredentialsFlow;
module.exports.request = oAuth2Request;
//# sourceMappingURL=index.js.map